// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveTransferMajorCourseBlockDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import TransferMajorCourseBlockDTO from '../models/TransferMajorCourseBlockDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    transferMajorCourseBlockId: number;
    transferMajorCourseBlock: TransferMajorCourseBlockDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            transferMajorCourseBlockId: 0,
            transferMajorCourseBlock: null,
        },
        initValues);
    },
    transferMajorCourseBlockId: 'transferMajorCourseBlockId',
    transferMajorCourseBlock: 'transferMajorCourseBlock',
}

interface Result extends ResultDTO {
    transferMajorCourseBlock: TransferMajorCourseBlockDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            transferMajorCourseBlock: null,
        },
        initValues);
    },
    transferMajorCourseBlock: 'transferMajorCourseBlock',
}

export { Request, Result };